import React from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

// css
import "./App.css";
import "./assets/css/reset.css";
import "./assets/css/root.css";

// components
import Landing from "./pages/landing/Landing.jsx";
import Nav from "./components/common/bar/Navbar.jsx";
import Footer from "./components/common/footer/Footer.jsx";
import Mentions from "./pages/legal/mentions.jsx";
import Cookies from "./pages/legal/cookies.jsx";
import Concept from "./pages/concept/Concept.jsx";
import Place from "./pages/place/Place.jsx";
import About from "./pages/about/About.jsx";
import Contact from "./pages/contact/Contact.jsx";
import Partners from "./pages/partners/Partners.jsx";
import ScrollToTop from "./function/scrollToTop.js";
import Workshops from "./pages/workshops/Workshops.jsx";
import Workshop from "./pages/workshops/Workshop.jsx";
import Partner from "./pages/partners/Partner.jsx";
import Calendar from "./pages/calendar/Calendar.jsx";
import WorkshopsList from "./pages/workshops/WorkshopsList.jsx";
import Elements from "./pages/elements/Elements.jsx";
import Flyers from "./pages/calendar/Flyers.jsx";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <Nav />
          <ScrollToTop />
          <Outlet />
          <Footer />
        </>
      ),
      children: [
        {
          path: "",
          element: <Landing />,
        },
        {
          path: "/le-concept",
          element: <Concept />,
        },
        {
          path: "/le-lieu",
          element: <Place />,
        },
        {
          path: "/nous-connaitre",
          element: <About />,
        },
        {
          path: "/contact",
          element: <Contact />,
        },
        {
          path: "/calendrier",
          element: <Calendar />,
        },
        {
          path: "/calendrier/flyers/:id",
          element: <Flyers />,
        },
        {
          path: "/elements/:id",
          element: <Elements />,
        },
        {
          path: "/partenaires",
          element: <Partners />,
        },
        {
          path: "/partenaire/:id",
          element: <Partner />,
        },
        {
          path: "/ateliers",
          element: <Workshops />,
        },
        {
          path: "/ateliers/:id",
          element: <WorkshopsList />,
        },
        {
          path: "/atelier/:id",
          element: <Workshop />,
        },
        {
          path: "/legal/mentions",
          element: <Mentions />,
        },
        {
          path: "/legal/cookies",
          element: <Cookies />,
        },
      ],
    },
  ]);

  return (
    <div className="App" id="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
